import React from 'react'

export const HiddenTextArea = React.forwardRef<
  HTMLTextAreaElement,
  {
    value: string | number | readonly string[] | undefined
    name: string | undefined
    form: string | undefined
    isRequired?: boolean
    minLength?: number
    maxLength?: number
  }
>(({ value, name, form, isRequired, minLength, maxLength }, ref) => {
  return (
    <textarea
      style={{
        border: 0,
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px',
        whiteSpace: 'nowrap'
      }}
      aria-required={isRequired}
      required={isRequired}
      tabIndex={-1}
      aria-hidden="true"
      value={value}
      onChange={() => {}}
      ref={ref}
      name={name}
      form={form}
      minLength={minLength}
      maxLength={maxLength}
    />
  )
})
HiddenTextArea.displayName = 'HiddenTextArea'
